(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        if (this.getAttribute('data-url') && !this.classList.contains('loaded')) {
          this.fetchRecommendations();
        }
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
    }

    fetchRecommendations() {
      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
            this.classList.add('loaded');

            // Re-initialize lazyload for new images
            if (typeof window.lazySizes !== 'undefined') {
              window.lazySizes.init();
            }

            // Dispatch event for other scripts
            this.dispatchEvent(new CustomEvent('recommendations-loaded', {
              bubbles: true,
              detail: { section: this }
            }));
          } else {
            this.classList.add('loaded');
            this.style.display = 'none';
          }
        })
        .catch(e => {
          console.error('Product recommendations error:', e);
          this.classList.add('loaded');
          this.style.display = 'none';
        });
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
